import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { designSystem, reactHookForm } from '@yola/ws-ui';

const { useController } = reactHookForm;

const { FieldStatus, Tag, Paragraph } = designSystem;

const defaultRules = {};

const IconInputField = ({
  control,
  name,
  captions,
  onClick = Function.prototype,
  rules = defaultRules,
}) => {
  const { fieldState, field } = useController({
    name,
    control,
    rules,
  });

  const iconNameText = useMemo(() => {
    if (!field.value) return captions.empty;

    const srcPartsArray = field.value.split('/');
    const iconName = srcPartsArray.pop();
    return iconName || srcPartsArray.pop();
  }, [field.value, captions.empty]);

  return (
    <React.Fragment>
      <div className="ws-icon-input-field">
        {field.value && (
          <span className="ws-icon-input-field__preview">
            <img className="ws-icon-input-field__img" src={field.value} alt="" />
          </span>
        )}
        <div className="ws-icon-input-field__input">
          <Tag label={captions.button} onClick={onClick} appearance="outline" />
          <Paragraph isClipped size="small" appearance="medium-emphasis">
            {iconNameText}
          </Paragraph>
        </div>
      </div>
      {fieldState.error && <FieldStatus text={fieldState.error.message} appearance="error" />}
    </React.Fragment>
  );
};

IconInputField.propTypes = {
  control: PropTypes.shape({}).isRequired,
  name: PropTypes.string.isRequired,
  captions: PropTypes.shape({
    button: PropTypes.string.isRequired,
    empty: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func,
  rules: PropTypes.shape({}),
};

export default IconInputField;
